import * as React from "react";
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { ReportingServicesCatalogItem, ImportSummaryResult } from "../../misc/api/apiTypes";

export interface ImportSummaryProps {
    isLoadingBaseReports: boolean;
    importResults: Array<ImportSummaryResult>;
    baseReports: ReportingServicesCatalogItem[];
}

export const ImportSummary = (props: ImportSummaryProps) => {
    const SummaryStateSelector = () => {
        switch (ImportResultsSelector()) {
            case "success":
                return AlertCategoryEnum.Success;
            case "info":
                return AlertCategoryEnum.Info;
            case "error":
                return AlertCategoryEnum.Danger;
            default:
                return AlertCategoryEnum.Info;
        }
    };

    const ImportResultsSelector = () => {
        if (props.importResults.length > 0) {
            if (props.importResults.filter(x => !x.IsSuccess).length > 0) {
                return "error";
            } else {
                return "success";
            }
        } else {
            return "info";
        }
    };

    const ImportSummaryFailedContent = () => {
        return (
            <>
                <p className="text-muted">
                    The following items failed to import to the report server:
                </p>
                <ul>
                    {props.importResults.filter(x => !x.IsSuccess).map(report => (
                        <li>
                            {report.ReportName} - {report.Message}
                        </li>
                    ))}
                </ul>
            </>
        );
    };

    const ImportSummarySuccess = () => {
        return (
            <>
                <p className="text-muted">
                    All items imported successfully
                </p>
            </>
        );
    };

    const ImportSummaryInitial = () => {
        return (
            <>
                <p className="text-muted">
                    The following items shall be imported to the report server selected below:
                </p>
                <ul>
                    {props.baseReports.map(report => (
                        <li key={`ListItem-${report.Name}`}>
                            {report.Name} - {report.Type}
                        </li>
                    ))}
                </ul>
            </>
        );
    };

    const SummaryTextSelector = () => {
        switch (ImportResultsSelector()) {
            case "success":
                return <ImportSummarySuccess />;
            case "info":
                return <ImportSummaryInitial />;
            case "error":
                return <ImportSummaryFailedContent />;
            default:
                return <LoadingWithMessage message="Loading Import Summary..." />
        }
    };

    return (
        <div className="row">
            <div className="col-md-12">
                {props.isLoadingBaseReports ? (
                    <LoadingWithMessage message="Loading Base Reports..." />
                ) : (
                    <Alert show={true} category={SummaryStateSelector()}>
                        <SummaryTextSelector />
                    </Alert>
                )}
            </div>
        </div>
    );
};
